module.exports = __webpack_public_path__ + "img/logo-white.6847c0c1.png";